import { Appointment } from "../../common/models/appointment.model";
import { Price, Offer } from "../../common/models/string-data.model";
import { Booking } from "../../rent/models/booking.model";
import { CarBusinessLine } from "../constants/car-basic-data";



export class CarBrief {
  offerId = '';
  carId = '';
  favorite = false;
  
  sellerId = '';
  sellerType = '';
  sellerName = '';
  sellerCountry = '';

  country = '';
  city = '';

  make = '';
  model = '';
  version = '';
  features: string[] = [];

  year = 0;
  mileage = 0;

  fuel = '';
  gearBox = '';

  created = '';

  buyPrice: Price = Price.getDefault();
  rentDayRate: Price = Price.getDefault();

  buyActive: boolean = false;
  rentActive: boolean = false;

  //imageFilename = '';
  imagesFilenames: string[] = [];

  offers: Offer[] = [];
  appointments: Appointment[] = [];
  bookings: Booking[] = [];
    

  constructor (mk?: string)  {
    this.make = mk!;
    this.appointments = [];
    this.offers = [];
    this.bookings = [];
    this.imagesFilenames = [];
  }

  public getCarPrice(businessLine: CarBusinessLine): Price{

    switch(businessLine.toString()){

      case CarBusinessLine.BUY.toString(): {
        return this.buyPrice;
      }

      case CarBusinessLine.RENT.toString(): {
        return this.rentDayRate;
      }

      default: {
        return Price.getDefault();
      }

    }
  }
}

 